module.exports = __webpack_public_path__ + "img/twitter.4ec05573.svg";